import { Text, type TextProps } from '@shared/components';

import { type QConfigRandomType } from '../../types';

export interface RandomConfigInformationProps extends TextProps {
  randomConfigType: QConfigRandomType | null;
}

const RANDOM_CONFIG_LABEL = {
  ALL_RANDOM: {
    title: 'สุ่มทั้งชุด',
    description: 'สลับตำแหน่งทุกข้อในชุดข้อสอบ',
  },
  FIXED: {
    title: 'เรียงตามลำดับ',
    description: 'แสดงข้อสอบตามลำดับ',
  },
  RANDOM_BY_PART: {
    title: 'สุ่มแยกตามหมวด',
    description: 'สุ่มข้อสอบที่อยู่ภายในหมวดเดียวกัน',
  },
  RANDOM_BY_HIERARCHY: {
    title: 'สุ่มตามลำดับชั้น',
    description: 'สุ่มข้อสอบที่อยู่ภายในลำดับชั้นเดียวกัน',
  },
};

export default function RandomConfigInformation(props: Readonly<RandomConfigInformationProps>) {
  const { randomConfigType, ...restProps } = props;

  if (!randomConfigType) {
    return <Text {...restProps}>-</Text>;
  }

  return (
    <Text {...restProps}>
      <Text component='span' variant='body1Semibold'>
        {RANDOM_CONFIG_LABEL[randomConfigType].title}:
      </Text>{' '}
      <Text component='span'>{RANDOM_CONFIG_LABEL[randomConfigType].description}</Text>
    </Text>
  );
}
